export default {
  title: 'Materiality Assessment',
  buttonTitle: 'Create new assessment',
  buttonTitle2: 'Add new assessment',
  subTitle: 'You haven\'t set up any materiality assessment yet.',
  titleInitiate: 'Materiality Assessment Initiate',
  hintInitiate: 'To continue creating, fill in all active pages',
  back: 'Back',
  initiate: 'Initiate',
  phaseUnderstanding: 'Phase 1 - Understanding',
  stakeholderID: 'Stakeholder ID',
  topicRefinementI: 'Topic Refinement I',
  topicI: 'Topic I',
  phaseGatherInsight: 'Phase 2 - Gather Insight',
  creation: 'Questions Templates',
  descriptionCreation: 'Create one or more question sets to use within your stakeholders surveys, '
  + 'interviews, and roundtables.',
  survey: 'Survey',
  interview: 'Interview',
  roundtables: 'Roundtables',
  insightsDashboard: 'Insights Dashboard',
  phaseIdentification: 'Phase 3 - Identification',
  topicRefinementII: 'Topic Refinement II',
  iroIdentification: 'IRO Identification',
  iroRefinement: 'IRO Refinement',
  iroAssignmentToSMEs: 'IRO Assignment to SME\'s',
  iroScoring: 'IRO Scoring',
  results: 'Results',
  actionsAndPriorities: 'Actions & Priorities',
  validateAndReview: 'Validate & Review',
  integrateIntoStrategy: 'Integrate into strategy',
  discloseAndReport: 'Disclose & Report',
  name: 'Name',
  description: 'Description',
  placeholderName: 'Add name here...',
  placeholderDescription: 'Add description here...',
  valueChainMaps: 'Value chain map(s)',
  valueChainMapDescription: 'Select base value chain map(s) for this materiality assessment.',
  selected: 'Selected',
  taskAssignedTo: 'User access',
  taskAssignedToDescription: 'Select user(s) allowed access to this materiality assessment.',
  emptyUserDescription: 'You haven\'t set up any user access yet.',
  btnAddUser: 'Add user',
  btnAddUserAccess: 'Add user access',
  addJobPosition: 'Add job position',
  typeJobPositionHere: 'Type job position here...',
  reportingStandards: 'Reporting standards',
  reportingStandardsDescription: 'Select reporting standards for this materiality assessment.',
  titleStakeholder: 'Value Chain name: {{vcmName}}',
  titleStakeholderDescription: 'Affected Stakeholder Selection',
  titleStepStakeholder: 'Select affected stakeholders',
  titleSecondStepStakeholder: 'Select important stakeholder',
  competitors: 'Competitors',
  detailsRefusal: 'Details of the refusal',
  emptySupplierDescription: 'You haven\'t set up any important suppliers yet.',
  emptyCustomerDescription: 'You haven\'t set up any important customers yet.',
  emptyInvestorDescription: 'You haven\'t set up any important investors yet.',
  emptyBoardDescription: 'You haven\'t set up any important boards yet.',
  emptyEmployeeDescription: 'You haven\'t set up any important employees yet.',
  emptyCompetitorDescription: 'You haven\'t set up any competitors yet.',
  emptyCommunityDescription: 'You haven\'t set up any important communities yet.',
  emptyMediaDescription: 'You haven\'t set up any important media yet.',
  emptyNGODescription: 'You haven\'t set up any important NGOs yet.',
  emptyAnalysisDescription: 'You haven\'t set up any important analysis yet.',
  addStakeholder: 'Add stakeholder',
  importantSuppliers: 'Important suppliers',
  importantCustomers: 'Important customers',
  selectImportantSuppliers: 'Select important suppliers',
  selectImportantCustomers: 'Select important customers',
  createNewSupplier: 'Create new supplier',
  createNewCustomer: 'Create new customer',
  addSupplier: 'Add supplier',
  createNewImportantSupplier: 'Create new important supplier',
  createNewImportantCustomer: 'Create new important customer',
  peers: 'Peers',
  importantInvestors: 'Important investors',
  addInvestor: 'Add investor',
  addAnInvestor: 'Add an investor',
  addAnBoardMember: 'Add a board',
  importantBoards: 'Important boards',
  addBoard: 'Add board',
  importantEmployees: 'Important employees',
  addEmployee: 'Add employee',
  addAnEmployee: 'Add an employee',
  emptyValueChainDescription: 'You haven\'t set up any value chain yet.',
  addValueChain: 'Add value chain',
  selectValueChain: 'Select value chain',
  valueChainName: 'Value Chain Name',
  createdBy: 'Created',
  updatedBy: 'Last modified',
  status: 'Status',
  addCustomer: 'Add customer',
  importantLocalCommunities: 'Important local communities',
  addCommunity: 'Add community',
  addLocalCommunity: 'Add a local community',
  importantMedia: 'Important media',
  addMedia: 'Add media',
  importantNGOs: 'Important NGOs',
  addNGO: 'Add NGOs',
  topicIdentificationAssistant: 'Topic Identification Assistant',
  nextRecord: 'To continue creating, fill in all active pages',
  investorsCustomersEvidenceTitle: 'Investors/customers evidence',
  investorsCustomersEvidenceSubTitle: 'Upload lists of questions received from customers and investors.',
  investorsCustomersEvidenceTitleBox: 'Choose a file or drag a file here',
  investorsCustomersEvidenceSubTitleBox: 'Accepted formats: xlsx. Maximum upload size: 5MB',
  createNewQuestion: 'Create a new question to group',
  createNewGroup: 'Create a new question group',
  addQuestion: 'Add question',
  addJustificationField: 'Add a field to justify the answer',
  otherNonCorporateDisclosures: 'Other Non-Corporate Disclosures which are reported elsewhere',
  otherNonCorporateDisclosuresDescription: 'Upload a list of regulatory and non regulatory discloures which are '
  + 'not normally part of a corporate discloure and do a frequency workcount on the key terms with the selec '
  + 'ted reporting ambition standard',
  uploadFileWithQuestions: 'Upload file with questions',
  addCompetitor: 'Add competitor',
  competitorAnalysis: 'Competitor Analysis',
  competitorAnalysisHint: 'Specify your closest competitors and peers to initiate Al driven desktop '
  + 'analysis of their disclosures.',
  companies: 'Companies',
  tooltipCompany: 'Delete one of companies for adding new one.',
  addModalCompetitor: 'Add a competitor',
  suppliers: 'Suppliers',
  customers: 'Customers',
  investors: 'Investors',
  boards: 'Boards',
  employees: 'Employees',
  local_communities: 'Local Communities',
  media: 'Media',
  regulators: 'Regulators',
  ngos: 'NGOs',
  nature: 'Nature',
  future_generations: 'Future Generations',
  others: 'Others',
  geographic_specific: 'Geographic Specific',
  sensitive_regions: 'Sensitive regions identified in value chain.',
  addGeographicSpecific: 'Add geographic specific',
  emptyGeographicDescription: 'The locations your business covers are not considered high-risk or hazardous.',
  addCustomSource: 'Add custom source',
  addCustomStockTicker: 'Add custom stock ticker',
  geographicSpecific: 'Geographic specific for this business',
  addSectorSpecific: 'Add sector specific',
  sectorSpecific: 'Sector Specific',
  highImpactIndustries: 'High impact industries identified in value chain.',
  sectorSpecificForBusiness: 'Sector specific for this business',
  sectorSpecificForBusinessDescription: 'The locations covered by your business do not present any '
  + 'sector-specific sensitivities or concerns.',
  delete: 'Delete',
  stakeholderAnalysis: 'Stakeholder Analysis',
  hintStakeholderAnalysis: 'Select from your list of affected stakeholders to initiate Al driven desktop analysis '
  + 'of their focus areas using publicly available data and private data sets.',
  surveys: 'Surveys',
  emptySurveysTable: 'You haven\'t created any surveys yet.',
  emptySentSurveysTable: 'You haven\'t sent any surveys yet.',
  emptySentInterviewsTable: 'You haven\'t sent any interviews yet.',
  emptySentRoundtablesTable: 'You haven\'t sent any roundtables yet.',
  createSurvey: 'Create survey',
  createSurveyDescription: 'Create user surveys to gather feedback, improve experiences, and make informed '
    + 'business decisions.',
  addNewQuestion: 'Add new question',
  addPrioritizeStandards: 'Add Prioritise Standards',
  prioritizeStandards: {
    title: 'Prioritise Standards',
    subTitle: 'Select reporting standard for this survey',
    standards: {
      ESRS: 'ESRS',
      GRI: 'GRI',
      IFRS: 'IFRS',
      SASB: 'SASB',
      TCFD: 'TCFD',
    },
  },
  addOption: 'Add option',
  surveyName: 'Survey name',
  surveyDescription: 'Description',
  questionText: 'Question text',
  enterQuestionText: 'Enter question text',
  answerType: 'Answer type',
  answerTypes: {
    short: 'Short answer',
    paragraph: 'Paragraph',
    singleSelect: 'Single Select',
    multipleSelect: 'Multiple Select',
    prioritise: 'Prioritise',
    prioritiseStandards: 'Prioritise Standards',
  },
  configure: 'Configure',
  completed: 'Completed',
  in_progress: 'In Progress',
  empty: 'Empty',
  noVCFound: 'No value chain found',
  specifyReasonForRefusal: 'Specify reason for refusal',
  pleaseSpecifyReasonForRefusal: 'Please provide a reason for refusal the selected stakeholder. '
  + 'You can restore them anytime.',
  loadingGeo: 'Loading geographic specific...',
  geographicRefreshProcessing: 'AI refresh is still running. You can continue once processing is complete.',
  geographicRefreshProcessingTooltip: 'AI refresh is still running. Please wait until processing is complete.',
  geographicRefreshSaveBlocked: 'Refresh geographic data before saving.',
  loadingQuestion: 'Importing investors/customers evidence...',
  loadingDisclosure: 'Loading disclosure...',
  loadingAnalysis: 'Loading stakeholder analysis...',
  refreshInformation: 'Refresh information',
  titleAnalysisEdit: 'Edit stakeholder analysis',
  lastUpdated: 'Last updated:',
  addCustomSector: 'Add custom sector',
  step1: 'Geographic Specific',
  step2: 'Analysis Geographic Specific',
  sectorSpecificStep1: 'Sector Specific',
  sectorSpecificStep2: 'Analysis Sector Specific',
  titleIROIdentification: 'IRO Identification, Refinement & Assignment',
  impacts: 'Impacts',
  risks: 'Risks',
  opportunity: 'Opportunity',
  opportunities: 'Opportunities',
  addNewImpact: 'Add new {{name}}',
  emptyIRODescription: 'You haven\'t added any {{name}} yet.',
  selectImpacts: 'Select {{name}}',
  addCustomImpact: 'Add custom {{name}}',
  emptyItemsTable: 'You haven\'t created any items yet.',
  loadingIRO: 'Loading IRO Identification, Refinement & Assignment...',
  loadingRecipientList: 'Loading recipient list...',
  loadingIROScore: 'Loading IRO Scoring...',
  impact: 'Impact',
  risk: 'Risk',
  editTemplate: 'Edit custom {{name}}',
  addCustomTemplate: 'Add custom {{name}}',
  emptyImpactsTable: 'You haven\'t added any impacts for this standard.',
  emptyTable: 'You haven\'t added any {{name}} for this standard.',
  refreshDaGeo: 'The data is outdated. Please refresh it.',
  titleIROScoring: 'IRO Scoring',
  financial: 'Financial',
  emptyTopicRefinement: 'You haven\'t set up any topic refinement yet.',
  initialCandidateTopics: 'Initial Candidate Topics',
  updateTopicIdentification: 'Update Topic Identification',
  topicRefinement: 'Loading Topic Refinement...',
  loadingTopicRefinementChart: 'Loading Topic Refinement Chart...',
  included: 'Included',
  excluded: 'Excluded',
  backToMainChart: 'Back to Main Chart',
  viewRespondentSurveys: 'View list of respondent surveys',
  loadingRespondentSurveys: 'Loading respondent surveys...',
  respondentSurveys: 'Respondent surveys',
  respondentSurveyResponses: 'View survey responses',
  typeYourMessageHere: 'Type your message here',
  chartIsEmpty: 'The chart is empty. Please select a value chain map to display the chart.',
  errorDetailsModalList: 'Error details list:',
  titleShort: 'Title',
  assign: 'Assign',
  companiesCountTooltip: 'Number of companies referencing this topic out of the total '
    + 'companies in Investors/Customer Request Analysis (Company Name column).',
  regionCountTooltip: 'Number of regions referencing this item out of the total regions in '
    + 'Non Sustainability Regulatory Disclosures → Country/Region.',
  email: 'Email',
  respondent: 'Respondent',
  addEmailButton: 'Add new email',
  sendEmailsButton: 'Send emails',
  emptyRespondentTable: 'You haven\'t added any respondents yet.',
  sendQuestionary: 'Send survey',
  comments: 'Comments',
  noComments: 'No comments',
  stakeholderIdentification: 'Stakeholder Identification',
  provideReasonForInclusionExclusion: 'Provide reason for inclusion / exclusion',
  specifyReasonForInclusionExclusion: 'Specify reason for inclusion / exclusion',
  specifyReasonForDecision: 'Specify reason for changing the decision',
  detailsInclusionExclusion: 'Details of the {{type}}',
  fields: {
    name: 'Name',
    role: 'Role',
    job: 'Job',
    action: 'Action',
    investor: 'Investor',
    contactName: 'Contact Name',
    shareCategory: 'Share Category',
    equity: 'Equity',
    contactEmail: 'Contact Email',
    durationOfInvestment: 'Duration of Investment',
    actions: 'Actions',
    boardMemberName: 'Board Member Name',
    boardMemberProfession: 'Board Member Profession or Area of Expertise',
    boardMemberCategory: 'Board Member Category',
    peerCompetitor: 'Peer / Competitor',
    department: 'Department',
    employeeRepresentativeName: 'Employee Representative Name',
    valueChainName: 'Value Chain Name',
    createdBy: 'Created',
    updatedBy: 'Last modified',
    status: 'Status',
    communityGroupName: 'Community Group Name',
    representationCategory: 'Representation Category',
    representativeName: 'Representative Name',
    internalLiaison: 'Internal Liaison',
    internalLiaisonEmail: 'Internal Liaison Email',
    mediaOrganisationName: 'Media Organisation Name',
    relevanceToCompany: 'Relevance to Company',
    ngoName: 'NGO Name',
    ngoContactName: 'NGO Contact Name',
    ngoContactEmail: 'NGO Contact Email',
    question: 'Question',
    questionType: 'Question Type',
    questionSourceType: 'Question Source Type',
    companyName: 'Company Name',
    source: 'Source',
    disclosure: 'Disclosure',
    category: 'Category',
    requiredBy: 'Required by',
    country: 'Country/Region',
    stockTicker: 'Stock ticker',
    website: 'Website',
    sector: 'Sector',
    seerCompetitor: 'Peer / Competitor',
    size: 'Size (Employee Numbers)',
    created: 'Created',
    lastModified: 'Last Modified',
    countryGeo: 'Country',
    state: 'State/County/Region',
    sensitivityName: 'Specific Sensitivity',
    sectorName: 'Sector Name',
    sectorLink: 'Sector Link',
    valueChain: 'Value Chain',
    fullName: 'Full Name',
    industry: 'Industry',
    industryCode: 'Industry NACA Code',
    sectorCode: 'Sector NACA Code',
    sizeEmployees: 'Size (Employee Numbers)',
    stakeholderType: 'Stakeholder Type',
    surveyName: 'Survey Name',
    description: 'Description',
    questionsCount: 'No. of questions',
    respondent: 'Respondent',
    justifyAnswer: 'Justify your answer',
    supplierName: 'Supplier Name',
    supplierSystemUniqueIdentifier: 'Supplier System Unique Identifier',
    supplierCode: 'Supplier Code',
    valueChainPosition: 'Value Chain Position',
    upstreamTier: 'Upstream Tier',
    ownership: 'Ownership',
    questionGroup: 'Question Group',
    search: 'Search by name',
    supplierExpenses: 'Supplier expenses($)',
    purchaseVolume: 'Purchase volume ($)',
    profit: 'Profit ($)',
    stockTickerName: 'Stock ticker name',
    stockTickerValue: 'Stock ticker value',
    sectorValue: 'Sector value',
    standard: 'Prioritise Standard',
    optionName: 'Option name',
    options: 'Question must have at least two option.',
    naceSector: 'NACE Sector',
    naceCode: 'NACE Code',
    topic: 'Topic',
    iroCategory: 'IRO Category',
    reportingFramework: 'Reporting Framework',
    impactStatus: 'Impact Status',
    positionOnValueChains: 'Position on Value Chains',
    iroDescription: 'IRO Description',
    topicName: 'Topic Name',
    subTopicName: 'Topic Subcategory',
    standardName: 'Standard Name',
    activeDecision: 'Decision',
    questionCount: 'Question Count',
    totalCompaniesCount: 'Companies Count',
    mentionedInCompaniesCount: 'Mentioned in Companies Count',
    disclosureCount: 'Disclosure Count',
    totalRegionCount: 'Region Count',
    mentionedInRegionsCount: 'Mentioned in Regions Count',
    surveyPosition: 'Survey',
    interviewsPosition: 'Interview',
    roundTablesPosition: 'Roundtables',
    email: 'Email',
    dateAndTime: 'Date and Time',
    type: 'Type',
    attachments: 'Attachments',
    iro: 'IRO',
    title: 'Title',
    date: 'Date',
    resend: '',
    valueChainMap: 'Value Chain Map',
    specificSensitivity: 'Specific Sensitivity',
    respondentType: 'Respondent type',
  },
  placeholder: {
    topic: 'Select topic',
    iroCategory: 'Select category',
    positionOnValueChains: 'Select position on value chains',
    selectImpactStatus: 'Select impact status',
    reportingFramework: 'Select reporting framework',
    typeHere: 'Type here',
    contactName: 'Contact name',
    selectCategory: 'Select category',
    selectProfessionOrArea: 'Select profession or area of expertise',
    selectRole: 'Select role',
    selectDepartment: 'Select department',
    selectType: 'Select type',
    companyName: 'Company name',
    typeWebsite: 'Type website',
    selectCountry: 'Select country/region',
    searchCompany: 'Search company',
    selectTicker: 'Select ticker',
    selectSector: 'Select sector',
    selectSeerCompetitor: 'Select seer or competitor',
    min: 'min.',
    max: 'max.',
    selectSpecificSensitivity: 'Select specific sensitivity',
    selectState: 'Select state, county or region',
    selectSource: 'Select source',
    typeSector: 'Type sector name',
    typeLink: 'Type sector link',
    selectIndustry: 'Select industry',
    enterYourAnswer: 'Enter your answer',
    selectValueChainMap: 'Select value chain map',
  },
  statusOptions: {
    draft: 'Draft',
    approved: 'Approved',
    in_progress: 'In Progress',
    ready_for_review: 'Ready for Review',
    done: 'Done',
    success: 'Success',
    pending_review: 'Pending Review',
  },
  saveDraftModal: {
    title: 'Save as draft?',
    description: 'Are you sure you want to close the survey without saving? If you don\'t save it as a draft, '
      + 'all your progress will be lost.',
    closeWithoutSaving: 'Close without saving',
    saveDraft: 'Save draft',
  },
  titleSurvey: 'Phase 2 - Gather Insight',
  surveyTemplates: 'Survey templates',
  roundTables: 'RoundTables',
  interviews: 'Interviews',
  chooseOne: 'Choose one',
  selectAllThatApply: 'Select all that apply',
  insightType: {
    survey: 'Survey',
    interview: 'Interview',
    roundtable: 'RoundTable',
  },
  nextStep: 'Next step',
  respondentDetails: 'Respondent details',
  respondentRole: 'Respondent role',
  field: 'Field',
  dragAndDrop: 'Drag and drop to rank options - 1 = most important.',
  anonymous: 'Anonymous',
  specifyYourPriorities: 'Specify Your Priorities',
  selectTheMostImportant: 'Select the most important topics',
  selectTheMostImportantDescribe: 'Select the most important topics in your opinion for our business?\n'
    + '(Hint: Select fewer topics to add most value. (For example: 2-3 topics is optimal).',
  continue: 'Continue',
  selectTopics: 'Select topics',
  selectSubTopics: 'Select Sub-topics',
  prioritise: 'Prioritise',
  selectTheMostImportantSub: 'Select the most important sub-topics',
  prioritiseYourTop10Topics: 'Prioritise your top 10 topics',
  clickAndDragTheTopic: 'Click and drag the topic of most importance to the position of greatest importance '
    + 'to least importance.\n 1 = Greatest importance.',
  template: 'Template',
  topic: 'Topic',
  stakeholder: 'Stakeholder',
  clearAll: 'Clear all',
  generate: 'Generate',
  settingWeighting: 'Setting Weighting',
  ranking: 'Ranking',
  applyGroupCoefficients: 'Apply group coefficients',
  AIAnalysis: 'AI Analysis',
  emptyChartData: 'To build the charts, use the items from the top menu.',
  resetCoefficients: 'Reset coefficients',
  resetCoefficientDescription: 'Are you sure you want to reset the coefficients?',
  yesReset: 'Yes, reset',
  no: 'No',
  typeStakeholder: 'Type stakeholder',
  weighting: 'Weighting',
  complete: 'Thanks for taking the time to complete our survey.',
  details: 'Details',
  descriptionKey: 'Description:',
  overview: 'Overview',
  severity: 'Severity',
  likelihood: 'Likelihood',
  stepsDescription: 'Some questions have been pre-populated based on the topic/Impact itself. For these you need to '
    + 'agree or disagree.',
  reasonModalTitle: 'Specify reason for disagree',
  reasonModalSubTitle: 'If you disagree with the selected choice and wish to change it, you need to write the '
    + 'reason for changing your choice.',
  reason: 'Reason',
  finishModalTitle: 'Add additional comment',
  finishModalSubTitle: 'Would you like to submit any additional comments or attach a supporting document?',
  comment: 'Comment',
  globalSend: 'Global Send',
  emptySentEmails: 'You haven\'t sent any emails yet.',
  success: 'Success',
  sent: 'Sent',
  'in-progress': 'In Progress',
  expired: 'Expired',
  counterHint: 'There are a few new respondent emails that haven’t been sent the survey yet. Send it from the '
    + 'Emails page.',
  selectIsRequired: 'Select is required.',
  refinementQuestions: 'Refinement Questions',
  refinementDisclosures: 'Refinement Disclosures',
  approve: 'Approve',
  returnForWork: 'Return for work',
  edit: 'Edit',
  finishMAHint: 'Once you submit this assessment for review, you will no longer be able to edit the '
  + 'information in this assessment and any pending surveys will expire. Are you sure you want to proceed?',
  reviewValidationError: 'Unable to submit this assessment for review. '
  + 'Please complete all required sections before submitting.',
  role: 'Role',
  valueChain: 'Value Chain',
  fullName: 'Full Name',
  industry: 'Industry',
  state: 'State',
};
